import React, { useEffect, useState } from "react";
import "../styles/shared-ui.css";
import "../styles/job-management.css";
import { getPersonById } from "../services/peopleService";
import { useAppContext } from "../context/AppContext";
import { toast } from "../utils/toast";
import { useLocation, useParams } from "react-router-dom";

const emptyForm = {
  name: "",
  surname: "",
  email: "",
  phone: "",
  is_manager: false,
  company_id: "",
  job_id: "",
  company_name: "",
  job_name: "",
};

const PeopleViewPage = () => {
  const { setActiveSection } = useAppContext();
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(true);
  const { personId: personIdParam } = useParams();
  const location = useLocation();

  useEffect(() => {
    let id = null;
    if (personIdParam) {
      const decoded = Number(decodeURIComponent(personIdParam));
      if (Number.isFinite(decoded) && decoded > 0) {
        id = decoded;
        try {
          localStorage.setItem("activePersonId", String(decoded));
        } catch {}
      }
    }
    if (!Number.isFinite(id) || id <= 0) {
      const pathParts = String(location.pathname || "")
        .split("/")
        .filter(Boolean);
      const peopleIndex = pathParts.lastIndexOf("people");
      if (peopleIndex >= 0) {
        const parsed = Number(pathParts[peopleIndex + 1]);
        if (Number.isFinite(parsed) && parsed > 0) {
          id = parsed;
          try {
            localStorage.setItem("activePersonId", String(parsed));
          } catch {}
        }
      }
    }
    if (!Number.isFinite(id) || id <= 0) {
      try {
        const stored = localStorage.getItem("activePersonId");
        if (stored) id = Number(stored);
      } catch {}
    }
    (async () => {
      try {
        setLoading(true);
        if (id) {
          const p = await getPersonById(id);
          setForm({
            name: p?.people_name || "",
            surname: p?.people_surname || "",
            email: p?.people_email || "",
            phone: p?.people_phone || "",
            is_manager: !!p?.is_manager,
            company_id: p?.company_id ?? "",
            job_id: p?.job_id ?? "",
            company_name: p?.company?.name || "",
            job_name: p?.job?.name || "",
          });
        }
      } catch (e) {
        toast.error(e?.message || "Failed to load person");
      } finally {
        setLoading(false);
      }
    })();
  }, [personIdParam, location.pathname]);

  const onClose = () => setActiveSection("people-management");

  if (loading) {
    return (
      <div className="page-container">
        <div className="page-header">
          <div className="header-content">
            <div>
              <h2 className="page-title">View Person</h2>
            </div>
          </div>
        </div>
        <div className="page-content">
          <div className="no-results">Loading person...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="header-content">
          <div>
            <h2 className="page-title">View Person</h2>
            <p className="page-subtitle">Read-only details.</p>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="role-card">
          <div
            className="form-grid"
            style={{ display: "grid", gap: 16 }}
          >
            <div className="field">
              <label>First Name</label>
              <input value={form.name} disabled />
            </div>
            <div className="field">
              <label>Surname</label>
              <input value={form.surname} disabled />
            </div>
            <div className="field">
              <label>Email</label>
              <input type="email" value={form.email} disabled />
            </div>
            <div className="field">
              <label>Phone</label>
              <input value={form.phone} disabled />
            </div>
            <div className="field">
              <label>Company</label>
              <input value={form.company_name || "-"} disabled />
            </div>
            <div className="field">
              <label>Job</label>
              <input value={form.job_name || "-"} disabled />
            </div>
            <div className="field" style={{ gridColumn: "1 / -1" }}>
              <label
                style={{
                  fontSize: 13,
                  color: "var(--gray-500)",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: 0.4,
                }}
              >
                Is Manager
              </label>
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  alignItems: "center",
                  marginTop: 6,
                }}
              >
                <label
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <input
                    type="radio"
                    name="is_manager_view"
                    value="true"
                    checked={form.is_manager === true}
                    disabled
                  />
                  Yes
                </label>
                <label
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <input
                    type="radio"
                    name="is_manager_view"
                    value="false"
                    checked={form.is_manager === false}
                    disabled
                  />
                  No
                </label>
              </div>
            </div>
          </div>
          <div className="actions" style={{ marginTop: 16 }}>
            <button type="button" className="secondary-btn" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeopleViewPage;
